import { ApplicationForm } from "@anginn/flexi-form";
import { FIREBASE_URL } from "../../config";
import { LOGOUT } from "./auth";
import { SET_FORMS } from "../reducers/forms";

export const createTemplate = () => {
	console.log("createTemplate");
	return async (dispatch, getState) => {
		const ACCESS_TOKEN = getState().auth.token;
		const application_template = getState().forms.applications;
		if (application_template !== undefined) {
			const response = await fetch(
				`${FIREBASE_URL}forms.json?auth=${ACCESS_TOKEN}`,
				{
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(application_template),
				}
			);

			if (!response.ok) {
				// throw new Error("Something went wrong!!!");
			}
			const resData = await response.json();
		}
	};
};

export const fetchForms = () => {
	console.log("fetchForms");
	return async (dispatch, getState) => {
		// console.log(`${FIREBASE_URL}applicants/${id}.json`);
		const ACCESS_TOKEN = getState().auth.token;
		const response = await fetch(
			`${FIREBASE_URL}forms.json?auth=${ACCESS_TOKEN}`
		);

		if (!response.ok) {
			dispatch({ type: LOGOUT });
		}

		const resData = await response.json();
		const formObjs = {};

		Object.entries(resData).map(([formId, form]) => {
			if (formId !== undefined) {
				let formObj = Object.assign(new ApplicationForm(), form);
				formObj.parseObject();
				formObjs[formId] = formObj;
			}
		});

		dispatch({ type: SET_FORMS, forms: formObjs });
	};
};

export const deleteData = () => {
	return async (dispatch, getState) => {
		// console.log(getState);

		const response = await fetch(`${FIREBASE_URL}applicants.json`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			// body: JSON.stringify({ sdf: "sdf" }),
		});

		if (!response.ok) {
			throw new Error("Something went wrong!!!");
		}

		const resData = await response.json();
	};
};
